import { render, staticRenderFns } from "./PortalDateField.vue?vue&type=template&id=bc3ac12e"
import script from "./PortalDateField.vue?vue&type=script&lang=ts"
export * from "./PortalDateField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports